import { EmailLink, Layout, PhoneLink, Text } from "@relode/core";
import * as React from "react";
import styled from "styled-components";

interface IMarketResearchUpSellMarketingSectionProps {
    jobManagerName: string;
    jobManagerPhoneNumber: string;
    jobManagerEmail: string;
}

export const MarketResearchUpSellMarketingSection = (
    props: IMarketResearchUpSellMarketingSectionProps
) => {
    const { jobManagerName, jobManagerEmail, jobManagerPhoneNumber } = props;

    // don't render unless we have a job manager
    if (!jobManagerName || !jobManagerEmail || !jobManagerPhoneNumber)
        return null;

    return (
        <Layout mode="100" gapSize="large">
            <MarketingSection>
                <Text variant="h2" gutterBottom>
                    get market research for all your jobs
                </Text>
                <Text variant="body1">Contact Relode for details.</Text>
                <br />
                <MarketingCta>
                    <Text variant="h5" gutterBottom>
                        {jobManagerName}
                    </Text>
                    {!!jobManagerPhoneNumber ? (
                        <PhoneLink
                            phone={jobManagerPhoneNumber}
                            variant="textAndIcon"
                        />
                    ) : null}
                    <EmailLink email={jobManagerEmail} variant="textAndIcon" />
                </MarketingCta>
            </MarketingSection>
        </Layout>
    );
};

const MarketingCta = styled.div`
    width: 100%;
    display: flex;
    flex-direction: column;
    justify-content: center;
`;

const MarketingSection = styled.div`
    margin: 0 0 32px 0;
`;
